





























































































import { Component, Vue, Watch, Mixins } from "vue-property-decorator";
import {
  setDefaultSysAddress, deleteSysAddress, saveAddress, sysAddressList,
} from "@/api/system";
import search from "@/utils/search";
import debounce from "@/utils/debounce";
import Loading from "@/mixins/loading";
import TablePagination from "@/mixins/tablePagination";
import copy from "@/utils/deepCopy";
import {Dictionary, SysAddress, SysAddressParam} from "@/types/api/system";

@Component
export default class CompanyAddress extends Mixins(Loading, TablePagination) {
  initData: any = [];
  tableData: any = []; // 数据列表
  keyword: string = ""; // 搜索关键字
  dialogVisible: boolean = false; //对话框
  // 初始化表单
  type: string = "add"; // add:添加  edit:编辑
  disabled: boolean = true;
  initForm: SysAddress = {
    addressName: "",
    receiverProvince: '',
    receiverCity: '',
    receiverRegion:'',
    receiverDetailAddress:'',
    receiverName:'',
    receiverPhone:'',
    id:0,
    defaultStatus:0,
  };
  form: SysAddress = this.initForm; // 表单

  /**
   * 生命周期
   */
  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();
    const param:SysAddressParam={keyword: ""};
    sysAddressList(param).then((res: any) => {
      this.tableData = res.data;
      this.initData = res.data;
      this.hideLoading();
    });
  }
  // 搜索
  handleSearch() {
    this.showLoading();
    let param:SysAddressParam={
      keyword:this.keyword,
    }
    sysAddressList(param).then((res: any) => {
      this.tableData = res.data;
      this.initData = res.data;
      this.hideLoading();
    });
  }
  // 添加
  handleAdd() {
    this.disabled = false;
    this.type = "add";
    this.form = JSON.parse(JSON.stringify(this.initForm)); // 深拷贝初始化
    this.dialogVisible = true;
  }
  setDefaultAddress(id:number){
    setDefaultSysAddress({
      id,
    }).then((res: any) => {
      this.$message.success("设置成功");
      this.getData();
    });
  }
  // 编辑
  handleEdit(row: SysAddress) {
    this.disabled = false;
    this.type = "edit";
    this.dialogVisible = true;
    this.form = copy(row);
  }
  // 删除
  handleDelete(id: number) {
    this.$confirm(`是否要删除该字典 (id:${id}) ?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteSysAddress({
        id,
      }).then((res: any) => {
        this.$message.success("删除成功");
        this.getData();
      });
    });
  }
  // 确认添加/修改
  async confirm() {
    let promi: any;
    promi = await saveAddress(this.form);
    if (promi.code == 200) {
      this.$message.success(this.type == "add" ? "添加成功" : "修改成功");
      this.form = JSON.parse(JSON.stringify(this.initForm));
      this.dialogVisible = false;
      this.getData();
    }
  }

}
